import CardLoading from '@op/components/CardLoading';
import ContentBody from '@op/components/ContentBody';
import { FilterFixed, useFilterDataHook } from '@op/components/FilterCommon';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Layout } from 'tea-component';
import { connect, getLocale, useIntl } from 'umi';
import './index.scss';
import {
  buriedBtnPoint,
  useInitBuriedPointInfo,
} from '@op/operationLog/buriedPoint';
import { localStoreSaveCountryToRegion } from '@op/utils';
import useTranslateTopic from '@op/hooks/useTranslateTopic';
import OpinionsSummary from './OpinionsSummary';
import NoticeableOpinions from './NoticeableOpinions';
import FilterBoxCommon from '@/pages/opinion/components/FilterBoxCommon';
import keyOpinions from '@op/operationLog/pages/keyOpinions';
import { compareFilterChange } from './utils';
import { PAGE_NAME } from '@op/constants/page';
import { DBO_TM } from '@op/utils/format';
import CardCommon from '@op/components/CardCommon';

const { Content } = Layout;
function KeyOpinions({ gameInfo, wholeGameInfo, userInfo }: any) {
  const { formatMessage } = useIntl();
  const {
    scrollBody,
    loading,
    filter,
    changeFilter,
    filterOptions,
    confirmRef,
    userSynchronousValue,
    changeUserSynchronousValue,
    filterCommonParams,
  } = useFilterDataHook({
    gameInfo,
    pageName: 'Overview_Performance',
    defaultUserSynchronousValue: { is_valid: [2, 1, 3] },
  });
  const { setTranslateTopicMap, translateTopicFunc, translateTopic } =
    useTranslateTopic(getLocale());

  useInitBuriedPointInfo({ buriedPoint: keyOpinions });
  const filterCondInfo = useRef({});
  const contentRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);
  const [isHourlyRefresh, setIsHourlyRefresh] = useState(false);

  const validDefault = useMemo(() => {
    return (
      userSynchronousValue?.is_valid?.length !== 0 &&
      !userSynchronousValue?.is_valid?.includes(0)
    );
  }, [userSynchronousValue]);

  const isFilterChanged = useMemo(() => {
    const flag = compareFilterChange(filter, filterCondInfo.current, { is_valid: [2, 1, 3] });
    console.log('是请求例行报告: ', flag);
    return flag;
  }, [filter]);

  useEffect(() => {
    if (scrollBody?.current && !loading) {
      if (contentRef?.current) {
        const { offsetTop } = contentRef.current;
        scrollBody.current?.scrollTo({ top: offsetTop, behavior: 'smooth' });
        setTimeout(() => {
          setScrolled(true);
        }, 500);
      }
    }
  }, [loading, scrollBody, contentRef]);

  const filterDefaultValue = {
    ...DBO_TM.utcFilterRangeDay(
      ...(wholeGameInfo.has_hot_content_task ? [0, 0] : [1, 1]),
    ),
    is_valid: [2, 1, 3],
  };

  return (
    <Content className="dbo-page-key-opinions" ref={scrollBody}>
      <ContentBody
        // pageName={PAGE_NAME.KEY_OPINIONS}
        contentHeard={
          <Content.Header
            className="dbo-header"
            title={formatMessage({ id: PAGE_NAME.KEY_OPINIONS })}
          ></Content.Header>
        }
      >
        <FilterFixed
          scrollBody={scrollBody}
          filter={filterOptions}
          confirmRef={confirmRef}
          userSynchronousValue={userSynchronousValue}
          {...filterCommonParams}
          defaultValue={filterDefaultValue}
          inheritStorageFilterValue={false}
          backCondOriginData={(options) => {
            localStoreSaveCountryToRegion(options?.region_country);
            setTranslateTopicMap(options?.topic_trans || []);
            filterCondInfo.current = options;
            setIsHourlyRefresh(options?.high_game_gpt_report_config?.is_hourly_refresh || false);
          }}
          confirm={(value: any) => {
            changeFilter({ ...value, ...gameInfo });
          }}
          hideTop={loading ? 150 : 200}
          otherRequestType={['high_game_gpt_report_config']}
        ></FilterFixed>

        <FilterBoxCommon
          className="dbo-metrics-filter-box"
          right={[
            {
              key: 'singleCheckbox',
              defaultValue: true,
              defaultParams: {
                value: validDefault,
                text: 'Exclude Invalid Reviews',
              },
            },
          ]}
          left={[]}
          onChange={(value) => {
            const isValid = value.singleCheckbox;
            if (isValid === validDefault) return;
            if (userSynchronousValue?.is_valid?.length === 0) {
              changeUserSynchronousValue({ is_valid: [2, 1, 3] });
            } else {
              const newValue = isValid ? [] : [0];
              const filterValue = userSynchronousValue?.is_valid?.filter(
                (item: any) => item !== 0,
              );
              const list = [...(filterValue || []), ...newValue];

              changeUserSynchronousValue({
                is_valid: list.length === 4 ? [] : list,
              });
            }

            buriedBtnPoint('KOOS_ExcludeInvalid', isValid);
          }}
        ></FilterBoxCommon>
        <div ref={contentRef}>
          <CardLoading loading={loading}>
            <OpinionsSummary
              filter={filter}
              gameInfo={gameInfo}
              userInfo={userInfo}
              translateTopic={translateTopic}
              isFilterChanged={isFilterChanged}
              wholeGameInfo={wholeGameInfo}
              isHourlyRefresh={isHourlyRefresh}
            />
            <NoticeableOpinions
              translateTopic={translateTopicFunc}
              filter={filter}
              gameInfo={gameInfo}
            />
          </CardLoading>
        </div>
        <>
          {!scrolled && (
            <CardCommon
              className="dbo-key-opinion-whole-screen-loading"
              loading={true}
            ></CardCommon>
          )}
        </>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { opinionCommon, opinionFilter, home } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    filter: opinionFilter,
    wholeGameInfo: opinionCommon.wholeGameInfo,
    userInfo: home.userInfo,
  };
})(KeyOpinions);
